function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(-3317 -1407)"
}, /*#__PURE__*/React.createElement("g", {
  id: "airplane"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#airplane0_fill",
  transform: "translate(3317 1407)"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "airplane0_fill",
  d: "M 28.419 40L 28.419 35L 24.172 30.44L 24.172 24.827L 40.1 29.6L 40.1 24.65L 24.169 13.35L 24.169 4.823C 24.172 2.163 22.325 0 20.051 0C 17.777 0 15.93 2.163 15.93 4.815L 15.93 13.341L 15.867 13.388L 0 24.646L 0 29.6L 15.931 24.824L 15.931 30.437L 11.684 34.992L 11.684 40L 20.052 35.729L 28.419 40ZM 13.089 35.532L 17.336 30.977L 17.336 22.964L 1.405 27.74L 1.405 25.364L 1.468 25.317L 17.336 14.052L 17.336 4.815C 17.336 2.92 18.552 1.373 20.052 1.373C 21.552 1.373 22.768 2.92 22.768 4.815L 22.768 14.051L 38.7 25.356L 38.7 27.732L 22.767 22.956L 22.767 30.969L 27.014 35.524L 27.014 37.734L 20.051 34.182L 13.088 37.742L 13.089 35.532Z"
}));

function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.8356f2bd.svg";
export { ForwardRef as ReactComponent };